import { useMemo, useState } from 'react'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { menuItemsAllowed } from '../../../../services/permission/menus'

export const BASE_MENU_ITEMS = ['1. Editar', '2. Posições']
export const FOTOGRAFIA_ESTOQUE_MENU_ITEM = { id: 137, content: '3. Fotografia Estoque' }

export function getMenuItems() {
  const fotografiaAllowed = menuItemsAllowed([FOTOGRAFIA_ESTOQUE_MENU_ITEM])
  return [...BASE_MENU_ITEMS, ...fotografiaAllowed]
}

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  FILTERING: 'Filtrando dados...',
  DELETE: 'Excluindo estoque...',
}

const MODAL_INIT_INFO = {
  name: '',
}

const INITIAL_STATE = {
  estoques: [],
  modal: {
    show: '',
    data: null,
  },
  modalFotografia: {
    show: false,
    data: null,
  },
  periodo: getPeriodoMesAtual(),
  selectedEstoque: {},
  pathToRedirect: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  successMessage: null,
  modalConfirmDelete: {
    show: false,
    data: null,
  },
}

export default function useCadastroEstoque() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          successMessage: null,
          pathToRedirect: null,
        }))
      },

      toggleModal(show, data, tp_id) {
        if (tp_id !== 0)
          setState(prevState => ({
            ...prevState,
            modal: { show, data: { ...data, tp_id: tp_id } },
          }))
        else
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione o Operador Logístico desejado',
          }))
      },

      async deleteEstoque(selectedTp, estoqueId) {
        EstoqueHttp.deleteEstoque(selectedTp, estoqueId)
          .then(() =>
            setState(prevState => ({
              ...prevState,
              estoques: prevState.estoques.filter(estoque => estoque.id !== estoqueId),
              loadingMessage: LOAD_MESSAGE.NONE,
              successMessage: 'Estoque deletado com sucesso',
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      onMenuItemClicked(item, estoque, selectedTp) {
        switch (item) {
          case '1. Editar':
            this.toggleModal(item, estoque, selectedTp)
            break
          case '2. Posições':
            setState(prevState => ({
              ...prevState,
              pathToRedirect: '/main/estoque/cadastro-posicoes-estoque',
              selectedEstoque: estoque,
            }))
            this.toggleModal(item, estoque, selectedTp)
            break
          case '3. Fotografia Estoque':
            setState(prevState => ({
              ...prevState,
              modalFotografia: { show: true, data: { ...estoque } },
            }))
            break
          case '2. Apagar':
            setState(prevState => ({
              ...prevState,
              selectedEstoque: estoque,
              modalConfirmDelete: { show: true, data: { ...estoque } },
            }))
            break
          default:
            break
        }
      },

      onModalFotografiaClose() {
        setState(prevState => ({
          ...prevState,
          modalFotografia: { show: false, data: null },
        }))
      },

      onModalFotografiaSave(updatedEstoque) {
        setState(prevState => {
          const index = prevState.estoques.findIndex(e => e.id === updatedEstoque.id)
          if (index !== -1) {
            prevState.estoques[index] = updatedEstoque
          }
          prevState.modalFotografia = { show: false, data: null }
          return { ...prevState }
        })
      },

      async getEstoque(selectedTp) {
        EstoqueHttp.getEstoques(selectedTp)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              estoques: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      onInit(selectedTp) {
        if (selectedTp)
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.FILTERING }))
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
      },

      onBtnNovo(selectedTp) {
        this.toggleModal('Novo', { ...MODAL_INIT_INFO }, selectedTp)
      },

      onModalClose() {
        setState(prevState => ({
          ...prevState,
          modal: { show: false, data: { ...MODAL_INIT_INFO } },
        }))
      },

      onModalSave(newEstoque) {
        setState(prevState => {
          const index = prevState.estoques.findIndex(e => e.id === newEstoque.id)
          if (index !== -1) {
            prevState.estoques[index] = newEstoque
          } else {
            prevState.estoques = [].concat([newEstoque], prevState.estoques)
          }

          prevState.modal = { show: false, data: { ...MODAL_INIT_INFO } }

          return { ...prevState }
        })
      },

      onMenuItemApagarClicked(estoque) {
        setState(prevState => ({
          ...prevState,
          selectedEstoque: estoque,
          loadingMessage: LOAD_MESSAGE.DELETE,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalDeleteClose() {
        setState(prevState => ({
          ...prevState,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalDeleteSave(estoque) {
        this.onMenuItemApagarClicked(estoque)
      },

      verifyMenuItemAllowed(menuItem) {
        return menuItemsAllowed([menuItem]).length > 0
      },

      onModalSaveProdutos(id, newPosicao) {
        setState(prevState => {
          const index = prevState.estoques.findIndex(estoque => estoque.id === id)

          prevState.estoques[index].posicoes = [newPosicao, ...prevState.estoques[index].posicoes]

          return prevState
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
